export function getChatPinnedMessages(meta) {
  if (Array.isArray(meta?.pinned_messages)) return meta.pinned_messages;
  return meta?.pinned_message?.id ? [meta.pinned_message] : [];
}

export function applyChatPinnedMessages(meta, payload) {
  const messages = Array.isArray(payload?.pinned_messages)
    ? payload.pinned_messages
    : payload?.pinned_message?.id ? [payload.pinned_message] : [];
  return {
    ...meta,
    pinned_messages: messages,
    pinned_message: messages[messages.length - 1] || null,
  };
}

export function removeChatPinnedMessage(meta, messageId) {
  const messages = getChatPinnedMessages(meta).filter(
    (message) => Number(message?.id) !== Number(messageId)
  );
  if (messages.length === getChatPinnedMessages(meta).length) return meta;
  return applyChatPinnedMessages(meta, { pinned_messages: messages });
}
